import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

export const getAdminChatUsers = async (values) => {
    return await axiosInstance(options).get(`admin/chat/get-user-list`, values);
}
export const getAdminChat = async (values) => {
    return await axiosInstance(options).post(`admin/chat/get-chat`, values);
}
export const ChatRoomDetails = async (roomID) => {
    return await axiosInstance(options).get(`admin/chat/get-room-details/${roomID}`);
}